import { Spinner } from "@stringf/ui/spinner";

/**
 * Suspense fallback for lazily-loaded routes. The fade is delayed so a chunk
 * that arrives from cache in a few milliseconds never flashes a spinner — the
 * user sees the page, not a blink of loading state.
 */
export function RouteFallback() {
  return (
    <div className="flex-1 min-h-0 h-full w-full flex items-center justify-center bg-bg-0 animate-in fade-in duration-200 delay-200 fill-mode-backwards">
      <Spinner />
    </div>
  );
}
